import React from 'react';

import { OpenOutline } from '@aurora/icons-react';
import { H1, H2, Preamble, Paragraph, Link, Code } from '@aurora/widgets-react';

const Home = () => {
  const homepage =
    'https://www.smhi.se/professionella-tjanster/hallbara-stader/smhi-energiindex-och-graddagar-normalkorrigering-varme-1.185236';

  return (
    <React.Fragment>
      <H1>SMHI Real Estate API Documentation</H1>
      <Preamble>
        This is the developer documentation for consumers of the SMHI Real
        Estate API.
      </Preamble>
      <Preamble>
        Please visit{' '}
        <Link to={homepage}>
          SMHI Fastighet
          <OpenOutline />
        </Link>
        for more information about the products and services we provide.
      </Preamble>

      <Paragraph>The API consists of three services found at</Paragraph>

      <Paragraph>
        <Code>https://enlossws.smhi.se/api/auth</Code> for authentication,
      </Paragraph>
      <Paragraph>
        <Code>https://enlossws.smhi.se/api/history</Code> to request historical
        data,
      </Paragraph>
      <Paragraph>
        <Code>https://enlossws.smhi.se/api/forecast</Code> to request forecast
        data.
      </Paragraph>

      <Paragraph>UI of the OpenAPI specification is available at</Paragraph>
      <Paragraph>
        <Link to="https://enlossws.smhi.se/openapi/">
          https://enlossws.smhi.se/openapi/
        </Link>
      </Paragraph>

      <Paragraph>
        The OpenAPI specification is also available as json at
      </Paragraph>
      <Paragraph>
        <Link to="https://enlossws.smhi.se/openapi/json">
          https://enlossws.smhi.se/openapi/json
        </Link>
      </Paragraph>

      <H2>Authentication</H2>
      <Paragraph>
        When requesting data from the <Code>history</Code> or{' '}
        <Code>forecast</Code> services, an access token must be provided. The
        access token is used to authenticate customers. The access token is
        retrieved from the <Code>auth</Code> service using a customernr and a
        secret. See <Link to="/authentication">Authentication</Link> for more
        information.
      </Paragraph>

      <H2>Data Requests</H2>
      <Paragraph>
        Data requests are made to the <Code>history</Code> and{' '}
        <Code>forecast</Code> services. More information about these services
        are found at <Link to="/datarequests">Data Requests</Link>.
      </Paragraph>

      <H2>Products and Parameters</H2>
      <Paragraph>
        All customers are subscribers to combinations of products, places and
        typecases. A product, e.g. Energy Index Monthly Values, can be seen as a
        bundle of parameters. This API has no concept of products and all
        requests are made using parameternrs for the parameters. See{' '}
        <Link to="/products">Products</Link> for a table of all products and
        which parameters they consist of. See{' '}
        <Link to="/parameters">Parameters</Link> for information of all
        available parameters.
      </Paragraph>

      <H2>Places</H2>
      <Paragraph>
        A request is made for one place at a time using a unique identifier
        called placenr. See{' '}
        <Link to="https://github.com/SMHI-Fastighet/webservice-api-docs/blob/master/ortslista.csv">
          Placenrs
          <OpenOutline />
        </Link>
        for all available places and their placenrs.
      </Paragraph>

      <H2>Code Examples</H2>
      <Paragraph>
        Some basic code examples can be found in{' '}
        <Link to="codeexamples">Code Examples</Link>.
      </Paragraph>

      <H2>Staging Environment</H2>
      <Paragraph>
        The API has a staging environment available at{' '}
        <Code>https://enlossws-tst.smhi.se</Code>. If you also have a staging
        environment that you wish to connect to this, please contact us to setup
        credentials in this environment for you.
      </Paragraph>
    </React.Fragment>
  );
};

export default Home;
